import React from 'react';
import _ from 'lodash';
import SelectMat from './SelectMat';
import CustomiserTabs from './CustomiserTabs';

export default function LloydCustomiser({cart, lloyd, callbacks}) {
  // Logo/Lettering only for some vehicles
  // let logoOption = options.getOption('logo');
  // let letteringOption = false; // options.getOption('lettering_thread');

  let cartItems = cart.items.toArray();
  let customising = !!_.some(cartItems, (i) => i.rowsToCustomise());

  // FIXME snake_case

  return <section id="lloyd-customiser">
    <h2>Step 3: Customize Mats (Optional)</h2>

    <div id="lloyd-mats-to-customise">
      <h3>Apply customization to these mats
        <em>(each row priced separately):</em>
      </h3>

      {cartItems.map((item, i) => <SelectMat
        key={item.extended_part_number || i}
        cartItem={item}
        callbacks={callbacks}/>)}
    </div>

    {customising && <CustomiserTabs cart={cart} lloyd={lloyd} callbacks={callbacks} />}
  </section>
}
